module.exports = __webpack_public_path__ + "static/media/jaskaran_animated.9c6172e0.png";